import restClient from "../restClient";
import { useMutation } from "@tanstack/react-query";

import { useNotification } from "contexts/NotificationContext";

const BASE_URL = "/write-downs";

export const createWriteDown = async (data) => {
    const token = localStorage.getItem('token');
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await restClient.post(BASE_URL, { data }, config);
    return response.data;
};

export const useCreateWriteDown = () => {
    const { showNotification } = useNotification();

    return useMutation({
        mutationFn: createWriteDown,
        onSuccess: () => {
            showNotification('success', 'Write down posted successfully!');
        },
        onError: (error) => {
            let errorMessage = 'Error posting write down.';
            if (error?.response?.data?.error?.message) {
                errorMessage = error.response.data.error.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }
            showNotification('danger', errorMessage);
        },
    });
};
